import actions from "./actions";
import state from "./states";
import mutations from "./mutations";

const AccountModule = {
  namespaced: true,
  actions,
  state,
  mutations,
};

export default AccountModule;